module.exports = __webpack_public_path__ + "img/BlinkArt_Axe1H_Basic.c1c72077.png";